module.exports = __webpack_public_path__ + "img/color-options.55f42477.jpg";